import productSuggestions from './product-suggestions';
import ProductSuggestionsMobile from '../../../../components/product-suggestions/product-suggestions.mobile';

export default productSuggestions(ProductSuggestionsMobile);
